module.exports = __webpack_public_path__ + "static/media/lauren.e8ff2dca.png";